import React, { useState, useEffect } from "react";
import {
  Table,
  Card,
  Tag,
  Space,
  Typography,
  Spin,
  message,
  Button,
  InputNumber,
  Modal,
} from "antd";
import { Link } from "react-router-dom";
import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import Layouts from "../../../components/Layouts";
import {
  obtenerFormularios,
  eliminarFormulario,
} from "../../../services/formularios";
import { useSelector } from "react-redux";
import validarpermiso from "../../../lib/utils";

const { Title, Text } = Typography;
const { confirm } = Modal;

const ReporteFormularios = () => {
  const [formularios, setFormularios] = useState([]);
  const [loading, setLoading] = useState(true);

  const userBodega = useSelector((state) => state.userdata.bodega?.id);
  const userRoleID = useSelector((state) => state.userdata.role?.name);
  const permisos = useSelector((state) => state.permisos);
  useEffect(() => {
    cargarFormularios();
  }, []);

  const cargarFormularios = async () => {
    try {
      setLoading(true);
      const data = await obtenerFormularios(userRoleID, userBodega);
      // Ordenar los formularios por el orden de sus campos
      const formulariosOrdenados = data
        .map((form) => ({
          ...form,
          orden: form.campos_formulario?.[0]?.orden || null,
        }))
        .sort((a, b) => (a.orden || 0) - (b.orden || 0));
      setFormularios(formulariosOrdenados);
    } catch (error) {
      message.error("Error al cargar los formularios");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (id) => {
    confirm({
      title: "¿Estás seguro de que quieres eliminar este formulario?",
      icon: <ExclamationCircleOutlined />,
      content:
        "Esta acción eliminará el formulario y todos sus campos. Esta acción no se puede deshacer.",
      okText: "Sí, eliminar",
      okType: "danger",
      cancelText: "Cancelar",
      onOk: async () => {
        try {
          await eliminarFormulario(id);
          message.success("Formulario eliminado exitosamente");
          cargarFormularios(); // Recargar la lista
        } catch (error) {
          message.error("Error al eliminar el formulario");
        }
      },
    });
  };

  const columns = [
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "Descripción",
      dataIndex: "descripcion",
      key: "descripcion",
      ellipsis: true,
    },
    {
      title: "Bodega",
      dataIndex: ["bodega", "nombre"],
      key: "bodega.nombre",
      ellipsis: true,
      render: (_, record) => record.bodega?.nombre || "-",
    },
    {
      title: "Acciones",
      key: "acciones",
      render: (_, record) => (
        <Space>
          {validarpermiso("campos_formulario", "read", permisos) && (
            <Link to={`/formularios_reporte/ver/campos/${record.id}`}>
              <Button type="primary">Ver campos</Button>
            </Link>
          )}

          {validarpermiso("respuestas_formulario", "read", permisos) && (
            <Link to={`/formularios_reporte/ver/respuestas/${record.id}`}>
              <Button type="primary">Ver respuestas</Button>
            </Link>
          )}

          {validarpermiso("formularios", "delete", permisos) && (
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(record.id)}
            >
              Eliminar
            </Button>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Layouts>
      <div style={{ padding: "24px" }}>
        <Space direction="vertical" style={{ width: "100%" }}>
          {validarpermiso("formularios", "create", permisos) && (
            <Button type="primary">
              <Link to="/formularios">Crear formulario</Link>
            </Button>
          )}

          <Card>
            <Title level={2}>Reporte de Formularios</Title>
            <Spin spinning={loading}>
              <Table
                dataSource={formularios}
                columns={columns}
                rowKey="id"
                pagination={{
                  pageSize: 5,
                  showSizeChanger: true,
                  showTotal: (total) => `Total: ${total} formularios`,
                }}
              />
            </Spin>
          </Card>
        </Space>
      </div>
    </Layouts>
  );
};

export default ReporteFormularios;
